/* ==========================================================================
   LOYAL · THE LOOKBOOK
   Two behaviours, and they obey different laws on purpose.

   1 · THE SCRUB. Horizontal travel driven by vertical scroll. MOTION-SYSTEM
       section 3: linear, always, no easing and no smoothing. The visitor is
       moving time with their hand.

   2 · THE ENTRANCE. blurFadeUp per frame on the stagger ladder. Expo-out,
       900ms, delays already computed in the Liquid and capped at 900ms.

   THE MANUAL SCROLLER IS THE BASE STATE. Without this file the viewport is a
   real overflow-x container with snap points and the lookbook is draggable and
   complete. This only replaces manual scrolling with scrubbed scrolling, and
   it marks the section so the CSS can drop the manual axis. The two must never
   both own the horizontal, or they fight.
   ========================================================================== */

(function () {
  'use strict';

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  function init(root) {
    if (root.dataset.lbBound === '1') return;
    root.dataset.lbBound = '1';

    var frames = root.querySelectorAll('.loyal-lb__frame');

    /* ---- entrance ---- */
    if ('IntersectionObserver' in window && !reduce.matches) {
      var io = new IntersectionObserver(function (entries) {
        for (var i = 0; i < entries.length; i++) {
          if (entries[i].isIntersecting) {
            entries[i].target.setAttribute('data-loyal-reveal', 'in');
            io.unobserve(entries[i].target);
          }
        }
      }, { threshold: 0.2 });
      for (var i = 0; i < frames.length; i++) io.observe(frames[i]);
    } else {
      // No observer, or a visitor who asked for stillness: show them at once.
      for (var j = 0; j < frames.length; j++) frames[j].setAttribute('data-loyal-reveal', 'in');
    }

    /* ---- scrub ---- */
    var track = root.querySelector('[data-loyal-lb-track]');
    var view = root.querySelector('[data-loyal-lb-viewport]');
    var travel = parseFloat(getComputedStyle(root).getPropertyValue('--lb-travel')) || 0;

    /* DO NOT SCRUB ON A TOUCH DEVICE. Kailin, showing the site on a phone:
       "the galleries wouldn't scroll and wasn't a good experience."

       She is describing exactly this. The scrub sets overflow-x: clip so the
       manual scroller and the scrubbed one cannot fight over the same axis,
       which is correct on a mouse. On a phone it takes a row of photographs
       that a thumb would naturally swipe and makes it PHYSICALLY UNSWIPEABLE,
       moving only when the whole page moves. A gallery that ignores a swipe
       does not read as a different interaction, it reads as broken.

       Sideways is the axis a thumb already owns. So on coarse pointers the
       script leaves the native scroller alone and does nothing at all. */
    var coarse = window.matchMedia && window.matchMedia('(pointer: coarse)').matches;
    if (coarse) return;

    if (!track || !view || !travel || reduce.matches) return;

    // Never scrub what already fits. A row narrower than its viewport has
    // nothing to travel, and moving it would just push it off screen.
    if (track.scrollWidth <= view.clientWidth + 8) return;

    root.setAttribute('data-lb-scrubbed', '1');

    var max = track.scrollWidth - view.clientWidth;
    var ticking = false;

    function scrub() {
      ticking = false;
      var r = root.getBoundingClientRect();
      var vh = window.innerHeight || 1;

      // Linear map of section position to travel. 0 as the section's top meets
      // the viewport bottom, 1 as its bottom leaves the top.
      var p = (vh - r.top) / (vh + r.height);
      if (p < 0) p = 0;
      if (p > 1) p = 1;

      var x = -(p * max * (travel / 100));
      track.style.transform = 'translate3d(' + x.toFixed(2) + 'px, 0, 0)';
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(scrub);
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', function () {
      max = track.scrollWidth - view.clientWidth;
      onScroll();
    }, { passive: true });
    scrub();

    reduce.addEventListener('change', function (e) {
      if (!e.matches) return;
      track.style.transform = '';
      root.removeAttribute('data-lb-scrubbed');
    });
  }

  function boot() {
    var all = document.querySelectorAll('[data-loyal-lookbook]');
    for (var i = 0; i < all.length; i++) init(all[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else { boot(); }

  document.addEventListener('shopify:section:load', boot);
})();
